import { createContext, useContext, useState } from 'react';

const FormContext = createContext();

export const FormProvider = ({ children }) => {
  const [formValues, setFormValues] = useState({
    header: {
      name: 'New Task',
      branch: 'main'
    },
    config: {},
    crons: [],
    parameters: {}
  });
  const [cronMap, setCronMap] = useState({})

  const updateFormValues = (values) => {
    setFormValues((prev) => {
      return {
        ...prev,
        ...values,
      }
    });
  };

  const updateCronMap = (cronUid, values) => {
    setCronMap((prev) => ({
      ...prev,
      [cronUid]: values,
    }));
  };

  return (
    <FormContext.Provider
      value={{
        formValues,
        updateFormValues,
        cronMap,
        updateCronMap
      }}
    >
      {children}
    </FormContext.Provider>
  );
};

export const useFormContext = () => useContext(FormContext);
